import React from 'react';

const ChangePasswordHeader = () => {
    return (
        <div>
            <h1>Change Password</h1>
        </div>
    );
};

export default ChangePasswordHeader;
